import { ResponseData } from '@/types/http';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';
import { BookingApi } from '@/apis';
import { Coordination } from '@/types/location';
import { CouponOneTimeResponse } from '@/types/http-payload/coupon';
import { CommonType } from '@/types/enums';

export default class BookingStore extends BaseStore {
    bikeBookingDetail: any = undefined;
    paymentStatusHistory: any = null;
    listBikeLocation: any[] = [];
    deviceCurrentLocation: Coordination | null = null;
    modifiers: {
        booked: any[],
        blocked: Date[],
        disabled: Date[]
    } = { booked: [], blocked: [], disabled: [] };

    bikeImages: any[] = [];
    // option
    options: any = [];
    // coupon
    couponOneTimes: CouponOneTimeResponse[] = [];
    couponForever: CouponOneTimeResponse = {} as CouponOneTimeResponse;

    api: BookingApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            bikeBookingDetail: observable,
            bikeImages: observable,
            listBikeLocation: observable,
            deviceCurrentLocation: observable,
            options: observable,
            couponOneTimes: observable,
            modifiers: observable,
            paymentStatusHistory: observable,
            getBikeBookingDetail: flow.bound,
            getAllBikeInLocation: flow.bound,
            getBookingOption: flow.bound,
            postCheckingBookingData: flow.bound,
            postPayment: flow.bound,
            getCouponOneTimeInfo: flow.bound,
            getStatusPayment: flow.bound,
            getCouponForeverInfo: flow.bound
        });
        this.api = new BookingApi();
    }

    *getBikeBookingDetail(bikeId: number | string, locationId?: number | string, type?: CommonType) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getBikeBookingDetail, { id: bikeId, locationId, type });
            if (res?.ok) {
                this.bikeBookingDetail = res?.data || null;

                const { vehicleImageBefore, vehicleImageAfter, vehicleImageLeft, vehicleImageRight } = res.data;
                const images: any = [];

                if (vehicleImageRight?.filePath) {
                    images.push({
                        id: vehicleImageRight?.id,
                        filePath: vehicleImageRight?.filePath
                    });
                }

                if (vehicleImageLeft?.filePath) {
                    images.push({
                        id: vehicleImageLeft?.id,
                        filePath: vehicleImageLeft?.filePath
                    });
                }

                if (vehicleImageBefore?.filePath) {
                    images.push({
                        id: vehicleImageBefore?.id,
                        filePath: vehicleImageBefore?.filePath
                    });
                }
                if (vehicleImageAfter?.filePath) {
                    images.push({
                        id: vehicleImageAfter?.id,
                        filePath: vehicleImageAfter?.filePath
                    });
                }

                this.bikeImages = images?.length > 0 ? images : [];

                return res?.data;
            }
            return false;
        } catch (error) {
        }
    }

    *getAllBikeInLocation(locationId: number | string, params) {
        try {
            const payload = {
                ...params,
                page: 1,
                size: -1,
                id: locationId
            };

            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.getAllBikeInLocation, payload);
            if (res.ok) {
                this.listBikeLocation = res.data.elements;
                return true;
            }
            return false;
        } catch (error) {
        }
    }

    *getBookingOption() {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.getBookingOption);
            if (res.ok) {
                this.options = res.data;
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }

    *postCheckingBookingData(payload: any, disableLoading: boolean = false) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.postCheckingBookingData, payload, { hideLoading: disableLoading });
            if (res.ok) {
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }

    *postPayment(payload: any) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.postPayment, payload);
            if (res.ok) {
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }

    *getCouponOneTimeInfo(code: string) {
        try {
            const res: ResponseData<CouponOneTimeResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getCouponOneTimeInfo, code);
            if (res.ok) {
                return true;
            }
            return false;
        } catch (error) {
        }
    }

    *getStatusPayment(id: string | number) {
        try {
            const res: ResponseData<any> = yield this.rootStore.apiStore.call(this.api, this.api.getStatusPayment, id);
            if (res.ok) {
                this.paymentStatusHistory = res.data;
                return res;
            }
            return false;
        } catch (error) {
        }
    }

    *getCouponForeverInfo() {
        try {
            const res: ResponseData<CouponOneTimeResponse> = yield this.rootStore.apiStore.call(this.api, this.api.getCouponForeverOfUser);
            if (res.ok) {
                this.couponForever = res.data;
                return res.data;
            }
            return false;
        } catch (error) {
        }
    }

    clean(): void {
        super.clean();
        this.bikeBookingDetail = undefined;
        this.bikeImages = [];
    }
}
